import {
  getMonthlyPayrollReport as getMonthlyPayrollReportService,
  processMonthlyPayroll as processMonthlyPayrollService,
  updatePayrollTransactionStatus as updatePayrollTransactionStatusService,
} from "services/company/payrollManagement/processPayroll/processPayrollService";
import {
  getPayrollReportStart,
  getPayrollReportSuccess,
  getPayrollReportFailure,
  processMonthlyPayrollStart,
  processMonthlyPayrollSuccess,
  processMonthlyPayrollFailure,
  updateTransactionStatusStart,
  updateTransactionStatusSuccess,
  updateTransactionStatusFailure,
} from "./processPayrollSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch monthly payroll report
export const fetchMonthlyPayrollReport = (params) => async (dispatch) => {
  try {
    dispatch(getPayrollReportStart());
    const response = await getMonthlyPayrollReportService(params);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getPayrollReportSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg =
        response?.meta?.message || "Failed to fetch payroll report";
      dispatch(getPayrollReportFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch payroll report error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch payroll report";
    dispatch(getPayrollReportFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Process monthly payroll
export const processMonthlyPayroll = (payrollData) => async (dispatch) => {
  try {
    dispatch(processMonthlyPayrollStart());
    const response = await processMonthlyPayrollService(payrollData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(processMonthlyPayrollSuccess());
      showSuccessToast(
        response?.meta?.message || "Payroll processed successfully!",
      );
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to process payroll";
      dispatch(processMonthlyPayrollFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Process payroll error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to process payroll";
    dispatch(processMonthlyPayrollFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Update payroll transaction status
export const updatePayrollTransactionStatus =
  (transactionId, statusData) => async (dispatch) => {
    try {
      dispatch(updateTransactionStatusStart());
      const response = await updatePayrollTransactionStatusService(
        transactionId,
        statusData,
      );

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(
          updateTransactionStatusSuccess({ id: transactionId, ...statusData }),
        );
        showSuccessToast(
          response?.meta?.message ||
            `Transaction ${statusData.status} successfully!`,
        );
        return { success: true };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to update transaction status";
        dispatch(updateTransactionStatusFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Update transaction status error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to update transaction status";
      dispatch(updateTransactionStatusFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };
